var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88906 15.582C1.61172 9.42969 0.85 8.78516 0.85 6.5C0.85 3.39453 3.34023 0.875 6.475 0.875C9.58047 0.875 12.1 3.39453 12.1 6.5C12.1 8.78516 11.309 9.42969 7.03164 15.582C6.76797 15.9922 6.15273 15.9922 5.88906 15.582ZM6.475 8.84375C7.76406 8.84375 8.81875 7.81836 8.81875 6.5C8.81875 5.21094 7.76406 4.15625 6.475 4.15625C5.15664 4.15625 4.13125 5.21094 4.13125 6.5C4.13125 7.81836 5.15664 8.84375 6.475 8.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.4d1e501457c9b37ec18ddc6cb82fdf69.svg";
export { ForwardRef as ReactComponent };